import CREATE_EVENT_COMMENT from './CreateContentEventComment.graphql'
import CREATE_NOTE_COMMENT from './CreateNoteComment.graphql'
import GET_EVENT_COMMENTS from './GetEventComments.graphql'
import GET_NOTE_COMMENTS from './GetNoteComments.graphql'
import DELETE_COMMENT from './DeleteComment.graphql'
import COMMENT_SUBSCRIPTION from './CommentSubscription.graphql'

export { CREATE_EVENT_COMMENT, CREATE_NOTE_COMMENT, GET_EVENT_COMMENTS, GET_NOTE_COMMENTS, DELETE_COMMENT, COMMENT_SUBSCRIPTION }



// WEBPACK FOOTER //
// src/graphql/MyTrip/index.js